export const formatCurrency = (value) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value);
};

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString();
};

export const formatNumber = (value) => {
  return value >= 1000 ? value.toLocaleString() : value;
};

export const formatPercentage = (value) => {
  return `${value}%`;
}; 